import React from 'react';
import {
  FormGroup,
  FormSelect,
  FormSelectOption,
} from '@patternfly/react-core';

type Props = {
  id?: string;
  label?: string;
  name?: string;
  onChange?: (value: string) => void;
  options?: {
    enumOptions: any[];
  };
  placeholder?: string;
  disabled?: boolean;
  readonly?: boolean;
  required?: boolean;
  value?: string;
};

const PatternflySelect = ({
  id,
  label,
  name,
  onChange,
  options,
  placeholder,
  disabled,
  readonly,
  required,
  value,
}: Props) => {
  const optionsWithPlaceholder = placeholder
    ? [
        {
          value: undefined,
          label: placeholder,
          isPlaceholder: true,
        },
        ...options.enumOptions,
      ]
    : options.enumOptions;

  return (
    <FormGroup label={label} isRequired={required}>
      <FormSelect
        className="patternfly-select"
        isDisabled={Boolean(disabled || readonly)}
        isRequired={required}
        id={id}
        name={name}
        onChange={(_, option) => onChange(option)}
        value={value}
      >
        {optionsWithPlaceholder.map((option) => (
          <FormSelectOption
            isDisabled={option.disabled}
            key={option.value}
            value={option.value}
            label={option.label}
          />
        ))}
      </FormSelect>
    </FormGroup>
  );
};

export default PatternflySelect;
